import { TemplateDownloadBanner } from "@/components/template-download-banner";
import { PRODUCT_TEMPLATE_URL } from "@/constants/templates";

export default function ProductTemplateBanner() {
  return (
    <TemplateDownloadBanner
      title="Plantilla de Productos (Excel)"
      description="Descargá el Excel de ejemplo. Recordá usar los mismos Rubros y Subrubros que tus Proveedores para que el sistema pueda relacionarlos."
      href={PRODUCT_TEMPLATE_URL}
      buttonLabel="Abrir plantilla de Productos"
    />
  );
}

